import { STATUS_NUM } from 'common/constants';
import cookie from 'js-cookie';
import { useDomains } from 'portal-common/components/hooks/useDomains';
import React, { useEffect, useState } from 'react';

import {
  KEY_INTL_PREVIEW,
  KEY_LONG_PREVIEW,
  KEY_NEXT_PREVIEW,
  KEY_NEXT_PREVIEW_DATA,
  KEY_PREVIEW,
} from '../../constants';
import logger from '../../helpers/logger';

const mobileWidth = 768;

function removeCookies(cookieKeys = [], domains) {
  const removeDomains = [
    null, // 默认，next的preview用的不带开头点的原域名，清理
    `.${domains.QCLOUD_ROOT_HOST}`, // 根cookie域名
  ].map((domain) => domain?.replace(/(:\d+)/g, '')); // 去除端口号
  cookieKeys.forEach((cookieKey) => {
    removeDomains.forEach((domain) => {
      cookie.remove(cookieKey, {
        domain,
        path: '/',
      });
    });
  });

  logger.info('cookie remove intl_preview over', { cookieKeys, removeDomains });
}

export function PreviewTips() {
  const [previewTipStyle, setPreviewTipStyle] = useState({ height: '34px' });
  const domains = useDomains();
  useEffect(() => {
    if (window.innerWidth < mobileWidth) {
      setPreviewTipStyle({
        height: '62px',
      });
    }
  }, []);

  if (
    !location.href.includes(KEY_PREVIEW)
    && !location.href.includes(KEY_LONG_PREVIEW)
    && Number(cookie.get(KEY_INTL_PREVIEW)) !== STATUS_NUM.TRUE_NUM
  ) {
    return null;
  }

  return (
    <div className="J-doc-notice-wrap" style={previewTipStyle}>
      <div className="c-msg c-msg-warning" style={{ position: 'absolute', zIndex: '99', width: '100%' }}>
        <div className="c-msg-info" style={{ textAlign: 'center' }}>
          In&nbsp;
          <em style={{ color: '#00a4ff' }}>preview mode</em> now,&nbsp;
          <em style={{ color: 'red' }}>please do not promote this link!</em>
          <a
            className="link"
            data-bypass-xhr
            style={{ color: '#00a4ff', cursor: 'pointer' }}
            onClick={() => {
              removeCookies([KEY_NEXT_PREVIEW, KEY_NEXT_PREVIEW_DATA, KEY_INTL_PREVIEW], domains);
              setTimeout(() => {
                location.href = location.href.replace(KEY_LONG_PREVIEW, 'exit').replace(KEY_PREVIEW, 'exit');
              }, 1000);
            }}
          >
            &nbsp;Exit preview mode
          </a>
        </div>
      </div>
    </div>
  );
}
